import { Tooltip } from '~/components';
import { useHoursFormat } from '~/hooks';
import _ from 'lodash';
import pluralize from 'pluralize';
import React from 'react';

export default function ForecastHoursTooltip({ actual, forecast, children }) {
  const hoursFormat = useHoursFormat({ minimumFractionDigits: 0, maximumFractionDigits: 2 });

  const message = `${hoursFormat.format(forecast.forecasted)} forecast (estimate at complete) ${pluralize('hour', _.round(forecast.forecasted, 2))} comprised of ${hoursFormat.format(actual)} actual ${pluralize('hour', _.round(actual, 2))} plus ${hoursFormat.format(forecast.left)} plan ${pluralize('hour', _.round(forecast.left, 2))}.`;

  return (
    <Tooltip placement="top" message={message}>
      {children}
    </Tooltip>
  );
}
